export default __webpack_public_path__ + "static/media/Taycan.c1b9c80d.png";